import React from "react";
import { Col, Row, Badge } from "react-bootstrap";
import { Zoom } from "react-awesome-reveal";
import SplitNumber from "../../../components/SplitNumber";
import { IconArrowDown, IconArrowUp } from "../../../../assets/icons";

function TransactionItem(props) {
  const itemCharge = props.ItemCharge;
  let ChargeType = "";
  let color = "";
  let icon = "";
  let ChargeLabel = "";

  if (itemCharge) {
    ChargeType = "واریز";
    color = "success";
    icon = <IconArrowUp fillColor="green" />;
    ChargeLabel = "افزایش موجودی";
  } else {
    ChargeType = "برداشت";
    color = "danger";
    icon = <IconArrowDown fillColor="red" />;
    ChargeLabel = "کاهش موجودی";
  }

  return (
    <Col xs={12} lg={4} className="mt-3 mt-md-2 px-1">
      <Zoom triggerOnce={true} className="h-100">
        <div className="bg-white border rounded-4 p-3 h-100">
          <Row>
            <Col xs="auto" className=" my-auto pe-0 ps-2">
              {icon}
            </Col>
            <Col className="ps-1">
              <div className="d-flex justify-content-between mb-2">
                <div>
                  <span className="fs-085 text-muted">{ChargeType} : </span>
                  <span className="fw-bold">
                    <SplitNumber number={props.ItemPrice} />
                  </span>{" "}
                  تومان
                  <div className="mt-2">
                    <span className="fs-085 text-muted">موجودی : </span>{" "}
                    <SplitNumber number={props.Amount} /> تومان{" "}
                  </div>
                </div>
                <div>
                  <div className="fs-075  mb-1 text-end">
                    {props.ItemTime} - {props.ItemDate}
                  </div>
                  <Badge bg={color} className="w-100 fw-normal fs-075 mt-2">
                    {ChargeLabel}
                  </Badge>
                </div>
              </div>
            </Col>
            <Col xs={12}>
              <div className="text-dark pt-2 mt-1 border-dashed-top">
                <div className="text-center">{props.ItemDescription}</div>
                <div className="fs-085 text-muted mt-1 text-center">
                  {props.Title} {props.ItemCode}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Zoom>
    </Col>
  );
}
export default TransactionItem;
